<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    computed: {
        loginButtonText() {
            if(this.loggingIn) {
                return 'Logging In...'
            }

            return 'Log In'
        }
    },
    data() {
        return {
            email: '',
            password: '',
            loggingIn: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loggingIn = true
                let result = await this.$store.dispatch('login', { username: this.email, password: this.password })
                this.$emit('success', result.userResource)
            } catch(e) {
                const loginFailedMessage = 'Login failed, please check your login details and try again'

                throw this.axiosExtract(e, {
                    400: loginFailedMessage,
                    401: loginFailedMessage,
                })
            } finally {
                this.loggingIn = false
            }
        },
        isValid() {
            return this.email && this.password
        }
    }
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-card class="mt-5">
            <template v-slot:header>
                <div class="d-flex align-items-center justify-content-between">
                    <span>Member Log In</span>
                    <slot name="header-action" />
                </div>
            </template>
            <b-form-group label="Email Address or Username:">
                <b-form-input type="text" v-model="email" name="email" />
            </b-form-group>
            <b-form-group label="Your Password:">
                <b-form-input type="password" v-model="password" name="password" />
            </b-form-group>
            <slot />
            <div v-if="messages.length > 0">
                <b-alert :variant="message.variant" show v-for="(message, i) in messages" :key="i">{{ message.text }}</b-alert>
            </div>
            <template slot="footer">
                <b-button :to="{ name: 'signup', query: $route.query }" variant="link" size="sm">Register</b-button>
                <b-button :to="{ name: 'forgot_password', query: $route.query }" variant="link" size="sm">Forgot Password?</b-button>
                <b-button type="submit" :disabled="!isValid() || loggingIn" class="float-right">{{ loginButtonText }}</b-button>
            </template>
        </b-card>
    </b-form>
</template>